const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

const BASE = API_URL + '/api/forex'

export interface ForexRates {
  [currency: string]: number
}

export async function fetchForexRates(): Promise<ForexRates> {
  try {
    const res = await fetch(`${BASE}/rates`)
    if (!res.ok) return {}
    const data = await res.json()
    return data.rates || {}
  } catch {
    return {}
  }
}

export interface ForexOhlcvPoint {
  time: string
  open: number
  high: number
  low: number
  close: number
  volume: number | null
}

export interface ForexOhlcvData {
  symbol: string
  count: number
  data: ForexOhlcvPoint[]
}

export async function fetchForexChartData(pair: string, period = '1A'): Promise<ForexOhlcvData | null> {
  try {
    const res = await fetch(`${BASE}/chart?pair=${encodeURIComponent(pair)}&period=${period}`)
    if (!res.ok) return null
    const raw = await res.json()

    // Yeni backend formatı: { symbol, count, data: [{time, open, high, low, close, volume}] }
    if (raw && typeof raw === 'object' && !Array.isArray(raw) && Array.isArray(raw.data)) {
      return raw as ForexOhlcvData
    }

    // Eski backend formatı (henüz deploy edilmemiş): [{time, value}]
    if (Array.isArray(raw)) {
      return {
        symbol: pair,
        count: raw.length,
        data: (raw as { time: string; value: number }[]).map(p => ({
          time: p.time,
          open: p.value,
          high: p.value,
          low: p.value,
          close: p.value,
          volume: null,
        })),
      }
    }

    return null
  } catch {
    return null
  }
}

export function getRate(rates: ForexRates, from: string, to: string): number {
  if (from === 'USD') return rates[to] || 0
  if (to === 'USD') return rates[from] ? 1 / rates[from] : 0
  const fromRate = rates[from]
  const toRate = rates[to]
  if (!fromRate || !toRate) return 0
  return toRate / fromRate
}
